"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.requireAuthentication = requireAuthentication;

function requireAuthentication(store) {
  return function () {
    // don't return true if there is a login error
    // even though isAuthenticated returns true (ie., token exists for app), there is no guarantee that resource token exists.
    var hasError = !!store.getState().user.auth.loginError;
    return store.getState().user.auth.isAuthenticated && !hasError;
  };
}